import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { WarehouseCreateInput } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';
import { WAREHOUSES_QUERY_KEY } from './useWarehouses';
import { getErrorMessage } from '@utils/errorMessage';
import { useTranslation } from '@hooks/useTranslation';

export const useCreateWarehouse = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['warehouse', 'create'],
    mutationFn: async (input: WarehouseCreateInput) => {
      return await warehouseService.createWarehouse(input);
    },
    onSuccess: () => {
      toast.success(tActionMessages.warehouseCreatedSuccessfully);
      queryClient.invalidateQueries({ queryKey: WAREHOUSES_QUERY_KEY });
    },
    onError: (error: any) => {
      toast.error(getErrorMessage(error, 'Failed to create warehouse'));
    },
  });
};

export default useCreateWarehouse;
